import clsx from "clsx";

import type { ReactNode } from "react";

interface PlanSettingsDetailsPanelProps {
  children: ReactNode;
  className?: string;
}

export default function PlanSettingsDetailsPanel({
  children,
  className,
}: PlanSettingsDetailsPanelProps) {
  return (
    <div className="p-1 bg-white rounded-4xl border border-black-100">
      <div
        className={clsx(
          "h-full border border-black-100 rounded-3xl flex flex-col",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
